import { lazy } from "react";
import AuthGuard from "routes/AuthGuard";
import Loadable from "routes/Loadable";
import AdminLayout from "components/layouts/adminLayout";

//advance
const AdvanceList = Loadable(lazy(() => import("pages/advance")));
const AdvanceReturn = Loadable(lazy(() => import("pages/advance/AdvanceReturn")));
const AdvanceReturnRecords = Loadable(lazy(() => import("pages/advance/AdvanceReturnRecords")));

const AdvanceRoutes = {
  path: "advance",
  element: (
    <AuthGuard>
      <AdminLayout />
    </AuthGuard>
  ),
  children: [
    {
      path: "list",
      element: <AdvanceList />,
    },
    {
      path: "details/:id",
      element: <AdvanceReturn />,
    },
    {
      path: "return-records",
      element: <AdvanceReturnRecords />,
    },
  ],
};

export default AdvanceRoutes;
